/**
 * NC 代码数值格式化 —— 消除浮点精度问题，去除尾部多余零
 * 例如 -0.5000000000000001 → -0.5
 * @param {number} v 数值
 * @param {number} [decimals=4] 小数位数
 * @returns {string}
 */
export function fmtNC(v, decimals = 4) {
    return v.toFixed(decimals).replace(/\.?0+$/, "");
}

/**
 * 格式化角度（通常保留 2 位小数即可）
 */
export function fmtAngle(v) {
    return fmtNC(v, 2);
}
